//@flow
import React from 'react';

import {makeStyles, Typography, CircularProgress} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  loadingConversations: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '0.5rem',
    justifyContent: 'center',
    paddingBlock: '1rem',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    zIndex: 1000,
    backdropFilter: 'blur(5px)',
    padding: '.5rem',
  },
  text: {
    fontSize: '0.8rem',
  },
}));

export default function LoadingConversations() {
  const classes = useStyles();

  return (
    <div>
      <div className={classes.loadingConversations}>
        <CircularProgress size={20} />
        <Typography className={classes.text}>
          Sincronizando conversaciones, esto podría tardar unos minutos...
        </Typography>
      </div>
    </div>
  );
}
